var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22852 15.5596C12.3707 15.5596 15.7285 12.2017 15.7285 8.05957C15.7285 3.91743 12.3707 0.55957 8.22852 0.55957C4.08638 0.55957 0.728516 3.91743 0.728516 8.05957C0.728516 12.2017 4.08638 15.5596 8.22852 15.5596Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35022 6.79846H3.27717C2.97308 6.79846 2.72656 7.04498 2.72656 7.34907V8.89736C2.72656 9.20146 2.97308 9.44797 3.27717 9.44797H7.35022C7.65431 9.44797 7.90083 9.20146 7.90083 8.89736V7.34907C7.90083 7.04498 7.65431 6.79846 7.35022 6.79846Z",
    fill: "#002951"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1764 6.79846H9.10334C8.79925 6.79846 8.55273 7.04498 8.55273 7.34907V8.89736C8.55273 9.20146 8.79925 9.44797 9.10334 9.44797H13.1764C13.4805 9.44797 13.727 9.20146 13.727 8.89736V7.34907C13.727 7.04498 13.4805 6.79846 13.1764 6.79846Z",
    fill: "#002951"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2643 3.48645H6.19123C5.88714 3.48645 5.64062 3.73297 5.64062 4.03706V5.58535C5.64062 5.88945 5.88714 6.13596 6.19123 6.13596H10.2643C10.5684 6.13596 10.8149 5.88945 10.8149 5.58535V4.03706C10.8149 3.73297 10.5684 3.48645 10.2643 3.48645Z",
    fill: "#002951"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2643 10.111H6.19123C5.88714 10.111 5.64062 10.3575 5.64062 10.6616V12.2099C5.64062 12.514 5.88714 12.7605 6.19123 12.7605H10.2643C10.5684 12.7605 10.8149 12.514 10.8149 12.2099V10.6616C10.8149 10.3575 10.5684 10.111 10.2643 10.111Z",
    fill: "#002951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryConstruction);
export default __webpack_public_path__ + "static/media/summary-construction.8bc0afc1c7d5d4035c5868b734152b1f.svg";
export { ForwardRef as ReactComponent };